import request from '@/utils/request'

export function getAgentList(params) {
    return request({
        url: '/agent',
        method: 'get',
        params
    })
}

export function getAgentDetail(id) {
    return request({
        url: '/agent/' + id,
        method: 'get'
    })
}

export function addAgent(data) {
    return request({
        url: '/agent',
        method: 'post',
        data
    })
}

export function updateAgent(id, data) {
    return request({
        url: '/agent/' + id,
        method: 'put',
        data
    })
}

export function deleteAgent(id) {
    return request({
        url: '/agent/' + id,
        method: 'delete'
    })
}

export function updateAppStatus(id, data) {
    return request({
        url: '/agent/' + id,
        method: 'put',
        data
    })
}

export function getNonManageAgentInfo(params) {
    return request({
        url: '/show/NonManage',
        method: 'get',
        params
    })
}
